export function numberHeadings(json: any): any {
  return json;
}

export function renderMarks(text: string, marks?: any[]): string {
  if (!marks || marks.length === 0) return escapeHtml(text);
  let html = escapeHtml(text);
  for (const mark of marks) {
    switch (mark.type) {
      case 'bold':
        html = `<strong>${html}</strong>`;
        break;
      case 'italic':
        html = `<em>${html}</em>`;
        break;
      case 'underline':
        html = `<u>${html}</u>`;
        break;
      case 'strike':
        html = `<s>${html}</s>`;
        break;
      case 'code':
        html = `<code>${html}</code>`;
        break;
      case 'textStyle': {
        const s: string[] = [];
        if (mark.attrs?.color) s.push(`color:${mark.attrs.color}`);
        if (mark.attrs?.fontSize) s.push(`font-size:${mark.attrs.fontSize}`);
        if (s.length) html = `<span style="${s.join(';')}">${html}</span>`;
        break;
      }
      case 'link':
        html = `<a href="${escapeHtml(mark.attrs?.href ?? '#')}" target="_blank" rel="noopener">${html}</a>`;
        break;
    }
  }
  return html;
}

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function renderNode(node: any): string {
  if (!node) return '';
  switch (node.type) {
    case 'text':
      return renderMarks(node.text ?? '', node.marks);
    case 'heading': {
      const level = Math.min(node.attrs?.level ?? 1, 4);
      const inner = (node.content ?? []).map(renderNode).join('');
      return `<h${level}>${inner}</h${level}>`;
    }
    case 'paragraph': {
      const inner = (node.content ?? []).map(renderNode).join('');
      const cls = node.attrs?.pStyle ? ` class="ps-${node.attrs.pStyle}"` : '';
      return `<p${cls}>${inner}</p>`;
    }
    case 'bulletList':
      return `<ul>${(node.content ?? []).map(renderNode).join('')}</ul>`;
    case 'orderedList':
      return `<ol start="${node.attrs?.start ?? 1}">${(node.content ?? []).map(renderNode).join('')}</ol>`;
    case 'listItem':
      return `<li>${(node.content ?? []).map(renderNode).join('')}</li>`;
    case 'table':
      return `<table class="dtbl"><tbody>${(node.content ?? []).map(renderNode).join('')}</tbody></table>`;
    case 'tableRow':
      return `<tr>${(node.content ?? []).map(renderNode).join('')}</tr>`;
    case 'tableHeader': {
      const inner = (node.content ?? []).map(renderNode).join('');
      const colspan = node.attrs?.colspan > 1 ? ` colspan="${node.attrs.colspan}"` : '';
      const rowspan = node.attrs?.rowspan > 1 ? ` rowspan="${node.attrs.rowspan}"` : '';
      const bgStyle = node.attrs?.backgroundColor
        ? ` style="background:${node.attrs.backgroundColor}"`
        : '';
      return `<th${colspan}${rowspan}${bgStyle}>${inner}</th>`;
    }
    case 'tableCell': {
      const inner = (node.content ?? []).map(renderNode).join('');
      const colspan = node.attrs?.colspan > 1 ? ` colspan="${node.attrs.colspan}"` : '';
      const rowspan = node.attrs?.rowspan > 1 ? ` rowspan="${node.attrs.rowspan}"` : '';
      const bgStyle = node.attrs?.backgroundColor
        ? ` style="background:${node.attrs.backgroundColor}"`
        : '';
      return `<td${colspan}${rowspan}${bgStyle}>${inner}</td>`;
    }
    case 'blockquote':
      return `<blockquote class="callout">${(node.content ?? []).map(renderNode).join('')}</blockquote>`;
    case 'horizontalRule':
      return '<hr/>';
    case 'hardBreak':
      return '<br/>';
    case 'codeBlock':
      return `<pre><code>${(node.content ?? []).map(renderNode).join('')}</code></pre>`;
    case 'image':
      return `<img src="${escapeHtml(node.attrs?.src ?? '')}" alt="${escapeHtml(node.attrs?.alt ?? '')}" style="max-width:100%"/>`;
    default:
      return node.content ? (node.content as any[]).map(renderNode).join('') : '';
  }
}

export function renderContent(json: any): string {
  if (!json?.content) return '';
  return json.content.map((node: any) => renderNode(node)).join('');
}
